import styled from '@emotion/styled'
import { Link, Typography } from '@mui/material'
import { Box } from '@mui/system'
import WalletConnector from 'components/WalletConnector'
import { useModal } from 'react-modal-hook'
import TVLgauge from 'components/TVL'
import CoreContainer from 'core/CoreContainer'
import AccessDeniedModal from 'components/Modal/AccessDeniedModal'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { RouteName } from 'constants/constants'
import { accountStore, betaLaunchStore } from 'stores'
import { observer } from 'mobx-react-lite'
import { GitBook } from 'constants/externalLink'

const CustomContainer = styled(CoreContainer)`
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 120px 0px;
`

const Badge = styled(Box)`
  background: rgba(227, 97, 57, 0.12);
  width: min-content;
  border-radius: 50px;
  padding: 7px 12px;
`

const Welcome = observer(() => {
  const { eligible, address, loadEligible } = accountStore
  const { maxTVL } = betaLaunchStore
  const navigate = useNavigate()
  const [showAccessDenied, hideAccessDenied] = useModal(() => {
    return <AccessDeniedModal onClose={hideAccessDenied} />
  }, [])

  useEffect(() => {
    if (!eligible && address !== '' && !loadEligible) showAccessDenied()
    if (eligible) {
      navigate(RouteName.pool)
    }
  }, [address, eligible, loadEligible, navigate, showAccessDenied])

  return (
    <CustomContainer>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'start',
          gap: '100px',
          flexWrap: 'wrap',
        }}
      >
        <Box
          sx={{
            maxWidth: '440px',
            minWidth: '300px',
            padding: '0px 40px',
          }}
        >
          <Badge>
            <Typography
              variant="overline"
              fontWeight={700}
              color="primary"
              noWrap
            >
              Beta launch is now live!
            </Typography>
          </Badge>
          <Typography variant="h3" mb="10px">
            Earn yields & borrow with extreme flexibility
          </Typography>
          <Typography variant="body1" mb="40px">
            The beta launch is exclusively for whitelisted wallets.{' '}
            <Link
              href={GitBook.docs}
              target="_blank"
              display="inline-block"
              pt="-1px"
            >
              Learn more
            </Link>{' '}
            about the event and access.
          </Typography>
          <WalletConnector noShowAddress />
        </Box>
        <Box>
          <TVLgauge />
          <Typography variant="body1" textAlign="center" mt="40px">
            Max capacity{' '}
            <strong>${maxTVL.toNumber().toLocaleString('en-US')}</strong>
          </Typography>
        </Box>
      </Box>
    </CustomContainer>
  )
})

export default Welcome
